import tonStyles from './../ton.json'

const headText = {
  paragraphType: 'Heading',
  paragraphTagName: 'h4',
  paragraphName: 'A1',
  letterSpacing: 0,
  marginLeft: 0,
  marginTop: 2,
  color: tonStyles.colors.PrimaryBlack
}

const preTitle = {
  borderTopColor: tonStyles.colors.SecondaryGreySteel,
  letterSpacing: 0,
  color: tonStyles.colors.PrimaryBlack,
  textAlign: 'center',
  textAlignMedium: 'left',
  paragraphType: 'Heading',
  paragraphTagName: 'h4',
  paragraphName: 'A1',
  fontSize: 16,
  fontSizeMedium: 16,
  fontSizeLarge: 16,
  fontSizeXLarge: 16
}

const title = {
  color: tonStyles.colors.PrimaryBlack,
  fontSize: 80,
  fontSizeMedium: 60,
  fontSizeLarge: 60,
  fontSizeXLarge: 100,
  fontSizeAlphaNum: 48,
  textAlign: 'center',
  textAlignMedium: 'left',
  lineHeight: 1.2,
  lineHeightAlphaNum: '72px',
  marginTopMultiplier: 1,
  marginTopMultiplierMedium: 1,
  marginTopMultiplierLarge: 1,
  marginTopMultiplierXLarge: 1.5,
  marginBottomMultiplier: 3,
  marginBottomMultiplierMedium: 2.5,
  marginBottomMultiplierLarge: 2.5,
  marginBottomMultiplierXLarge: 3.5,
  marginTopMedium: 0,
  paragraphType: 'Heading',
  paragraphTagName: 'h3',
  paragraphName: 'B1'
}

const text = {
  textAlign: 'center',
  textAlignMedium: 'left',
  fontSize: 16,
  fontSizeMedium: 16,
  fontSizeLarge: 16,
  fontSizeXLarge: 16,
  marginBottom: 4
}

const marginMultipliers = {
  desktopLeft: 4,
  desktopRight: 5,
  tabletLeft: 4,
  tabletRight: 5,
  mobileLeft: 4,
  mobileRight: 4,
  bottomDivider: 0,
  arrowRight: 6.5,
  arrowRightLarge: 7.5,
  arrowLeft: 7,
  arrowLeftLarge: 7.5,
  rtlArrow: 5.5,
  rtlArrowLarge: 4.5
}

const paddingMultipliers = {
  mobileLeft: 0,
  mogileRight: 0,
  mobileBorderTop: 2,
  tabletBorderTop: 2,
  desktopBorderTop: 8
}

const heights = {
  mobile: 565,
  medium: 290,
  large: 270,
  xLarge: 350
}

const pids = {
  shadow: true,
  pidPadding: true,
  defaultWidth: 211,
  defaultHeight: 271,
  skeletonBottonMargin: 3,
  imageAspectRatio: 1.044
}

export default {
  preTitle,
  title,
  text,
  marginMultipliers,
  paddingMultipliers,
  heights,
  pids,
  headText
}
